import { PersonInput, PersonType } from "@/helpers/types/types.ts";

/**
 * Creates an array of PersonInput objects, needed for the calculateCart mutation
 */
export const createPersonsInputHelper = (adults: PersonInput[], children: PersonInput[]): PersonInput[] => {
  const adultsInput: PersonInput[] = adults?.map((adult) => ({
    age: Number(adult.age),
    type: PersonType.Adult,
  }));

  const childrenInput: PersonInput[] = children?.map((child) => ({
    age: Number(child.age),
    type: PersonType.Child,
  }));

  return adultsInput.concat(childrenInput);
};
